<template>
    <v-container  >
      <v-navigation-drawer :clipped="clipped" v-model="drawer" enable-resize-watcher app width="25%">
        <Siret v-bind:search="search" v-on:openSearchModal="chk_advanced_search=true" @displayetablissement="onDisplayEtablissement($event)"/>
      </v-navigation-drawer>
      <Etab ></Etab>
      <AdvancedSearch v-if="chk_advanced_search" @closeSearchModal="chk_advanced_search=false" @search="search=''"></AdvancedSearch>
    </v-container>
</template>

<script>
import Siret from "@/components/freeSearch/Siret";
import Etab from "@/components/etablissement/Etab";
import AdvancedSearch from "@/components/freeSearch/AdvancedSearch";

export default {
  name: 'Fiche',
  props: {},
  components: {
    Siret,
    Etab,
    AdvancedSearch,
  },

  beforeMount: function () {
    // récupération des parametres de la route
    if ("siret" in this.$route.params) {
      this.siret = this.$route.params.siret
    }
    if ("search" in this.$route.params) {
      this.search = this.$route.params.search
    }
  },
  data: () => ({
    drawer: true,
    clipped: false,
    siret: "",
    search: "",
    searchString: "",
    api_url: '',
    env: null,
    health: {},
    loading_health: true,
    health_error: null,
    request_status: '000',
    chk_advanced_search: false,
  }),
  methods: {

    onDisplayEtablissement(siret) {
      // event when clic on an Entreprise to view it's data
      this.siret = siret

    },



  },

}

</script>

<style>
#main-container {
  padding: 10px;
}
</style>
